import React, {
    Suspense, useEffect, useState
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEsTelefono } from "../../../../utils/esTelefono";

import { AppDispatch, RootState } from "../../../../globals";
import { setShowModal, setShowTransferCreditModal } from "../../../../redux/reducers/accountStatementReducer";
import Constants, {
    articleType,
    FINANCES_MODALS,
    PERMISSIONS_CODES,
    TRANSFER_MODAL_CONTENT
} from "../../../../constants";
import Header from "./header";
import AccountStatementCard from "../../../../components/accountStatementCard";
import { AccesoPlataforma } from "../../../../components/plataformas/plataformas";
import ArticleCardComponent from "../../../../components/articlesCard";
import CheckoutModalComponent from "../../../../components/modals/checkout/checkout";
import InvoiceDetailModalComponent from "../../../../components/modals/invoiceDetails/invoiceDetails";
import GenerateInvoiceModalComponent from "../../../../components/modals/generateInvoice/generateInvoice";
import PaymentDetailModalComponent from "../../../../components/modals/payments/detail/paymentDetails";
import CobrarEnRegistrar from "../../../../components/modals/payments/create/cobrarEnRegistrar";
import CancelInvoiceModalComponent from "../../../../components/modals/cancelInvoice/cancelInvoice";
import CancelPaymentModalComponent from "../../../../components/modals/payments/cancel/cancelPayment";
import UnderlineHeading from "../../../../components/underlineHeading";
import ShoppingCartButtonComponent from "../../../../components/buttons/shoppingCartButton/shoppingCartButton";
import { FinancesModalsTypes, TransferModalsTypes } from "../../../../types";
import ApplyCreditModalComponent from "../../../../components/modals/applied_credits/create/applyCredit";
import CreditDetailModalComponent from "../../../../components/modals/applied_credits/detail/creditDetail";
import SelectStudentComponent from "../../../../components/transferCredit/selectStudent/selectStudent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import TransferCreditModalComponent from "../../../../components/transferCredit/transferModal/transferCredit";
import PaymentUpdateModalComponent from "../../../../components/modals/payments/update/updatePayment";

import AsideModalComponent from "../../../../components/modals/asideModal";
import ModalComponent from "../../../../components/modals/modal/modal";
import "../finanzasLayout.css";
import RegisterPaymentModal from "../../../../components/modals/payments/register/registerPaymentModal";
import RS from "../../../../components/modals/payments/register/strings";
import ReceiptDetailModal from "../../../../components/modals/payments/multi/receiptDetailModal";
import { useTieneCaja } from "../../../../components/aprobaciones/enviarAprobacion";
import EximirMesesModal from "../../../../components/modals/eximirMeses/eximirMesesModal";
import CambiarPromocion from "../../../../components/promos/cambiarPromocion";
import LimpiezaDelAlumno from "../../../../components/promos/limpiezaDelAlumno";
import CambiarMontoInscripcion from "../../../../components/accountStatementCard/cambiarMontoInscripcion";
import useCambioPromoAcceso from "../../../../components/promos/useCambioPromoAcceso";
import HttpManager from "../../../../services/HttpManager";
import CargarProductos from "../../../../components/kits/cargarProductos";
import { getAccessPermissions } from "../../../../common";

const AccountStatementView = (props: any) => {
    const esTelefono = useEsTelefono(1024);
    const {
        accountStatementProps,
        tableProps,
        checkoutDataProps,
        invoiceDetailProps,
        paymentDetailProps,
        emitPaymentProps,
        cancelPaymentProps,
        generateInvoiceProps,
        cancelInvoiceProps,
        applyCreditProps,
        appliedCreditsDetailProps,
        transferCreditProps,
        paymentUpdateProps,
        multiPaymentProps,
        cargarProductosProps
    } = props

    const dispatch = useDispatch<AppDispatch>();
    // Eximir meses (2026-10-28): solo Supervisión de Caja del plantel y superadmin ven el botón en cada curso.
    const eximir = accountStatementProps?.eximir || null;
    const [puedeEximir, setPuedeEximir] = useState<boolean>(false);
    const [eximiendo, setEximiendo] = useState<any | null>(null);
    // Fase 2 (2026-10-31): Caja del plantel también ve «Eximir Meses»; si no es Supervisión, la ventana lo manda a Aprobación.
    const tieneCaja = useTieneCaja();
    useEffect(() => {
        if (!eximir?.campusId) return;
        let vigente = true;
        HttpManager.getInstance().financesService.exemptionsAccess(eximir.campusId)
            .then((r) => vigente && setPuedeEximir(!!r.data.canManage))
            .catch(() => vigente && setPuedeEximir(false));
        return () => { vigente = false; };
    }, [eximir?.campusId]);
    const permissions: any[] = useSelector((state: RootState) => state.rootReducer.sessionState.permissions);
    // Cargar Productos (2026-10-31): el cargo de Nueva Venta sin salir de la cuenta; lo ve quien puede vender (Nueva Venta: Crear).
    const currentUser: any = useSelector((state: RootState) => state.userProfile.value);
    const puedeCargar: boolean = !!getAccessPermissions(currentUser, "newSale").create;
    const [cargando, setCargando] = useState<boolean>(false);
    const showModal: boolean = useSelector((state: RootState) => state.rootReducer.accountStatement.showModal);
    const showTransferCreditModal: boolean = useSelector((state: RootState) => state.rootReducer.accountStatement.showTransferCreditModal);
    const modalContent: any = useSelector((state: RootState) => state.rootReducer.accountStatement.modalContent);
    const transferModalContent: any = useSelector((state: RootState) => state.rootReducer.accountStatement.transferModalContent);
    const generalData: any = useSelector((state: RootState) => state.rootReducer.accountStatement.generalData);
    // Cambiar Promoción (2026-10-31): el botón sale según `canChange` de la matrícula (Caja, Supervisión, Dirección de Ventas), no según Eximir.
    // Recorrer Pagos ya no está aquí (Esteban, 2026-11-02): desde el 1-nov se recorre al aplicar el cambio en Actualizaciones.
    const cambioPromo = useCambioPromoAcceso(eximir?.campusId, (generalData?.courses || []).filter((c: any) => c.enrollmentId && !c.isPlatform).map((c: any) => c.enrollmentId));
    const [cambiandoPromo, setCambiandoPromo] = useState<any | null>(null);
    // «Cambiar Monto» de la inscripción (2026-10-31): Caja del plantel (Pagos: crear o editar).
    const [cambiandoInsc, setCambiandoInsc] = useState<any | null>(null);
    /*
        Limpieza sin hacer (Esteban, 2026-11-02, todos los planteles): la matrícula que sigue «Por revisar» lleva «Revisar Promoción», que
        abre su Limpieza aquí mismo. Hasta decidirla, el servidor no cobra sus mensualidades ni deja cambiarle o ponerle descuento por otro lado.
    */
    const [limpPend, setLimpPend] = useState<any[]>([]);
    const [revisando, setRevisando] = useState<any | null>(null);
    const [limpVuelta, setLimpVuelta] = useState<number>(0);
    useEffect(() => {
        if (!eximir?.campusId || !eximir?.studentId) { setLimpPend([]); return; }
        let vigente = true;
        HttpManager.getInstance().paymentService.cleanupPending(eximir.campusId, eximir.studentId)
            .then((r: any) => vigente && setLimpPend(r.data?.rows || []))
            .catch(() => vigente && setLimpPend([]));
        return () => { vigente = false; };
    }, [eximir?.campusId, eximir?.studentId, generalData, limpVuelta]);
    const limpDe = (enrollmentId: number) => limpPend.find((p: any) => p.enrollmentId === enrollmentId) || null;
    const toStudent: any = useSelector((state: RootState) => state.rootReducer.accountStatement.studentWhoReceives);
    const payment: any = useSelector((state: RootState) => state.rootReducer.accountStatement.selectedPayment);
    const invoice: any = useSelector((state: RootState) => state.rootReducer.accountStatement.selectedInvoice);
    const credit: any = useSelector((state: RootState) => state.rootReducer.accountStatement.selectedCredit);
    const itemsInInvoice: any = useSelector((state: RootState) => state.rootReducer.accountStatement.invoiceItems);
    const totalToPaid: any = useSelector((state: RootState) => state.rootReducer.accountStatement.totalToPaid);
    const totalCheckoutItems: number = useSelector((state: RootState) => state.rootReducer.accountStatement.totalCheckoutItems);

    const renderModalContent = (children: FinancesModalsTypes) => {
        switch (children) {
            case FINANCES_MODALS.CHECKOUT:
                return (
                    <CheckoutModalComponent
                        student={generalData?.student}
                        data={checkoutDataProps.checkoutData}
                        closeModal={checkoutDataProps.closeModal}
                        goToProccessPayment={checkoutDataProps.goToProccessPayment}
                    />
                );
            case FINANCES_MODALS.INVOICE:
                return (
                    <InvoiceDetailModalComponent
                        student={generalData?.student}
                        invoice={invoice}
                        closeModal={invoiceDetailProps.closeModal}
                        showPaymentDetail={invoiceDetailProps.showPaymentDetail}
                        showCreditDetail={invoiceDetailProps.showCreditDetail}
                        cancelInvoice={invoiceDetailProps.cancelInvoice}
                        proccessPayment={invoiceDetailProps.proccessPayment}
                    />
                );
            case FINANCES_MODALS.GENERATE_INVOICE:
                return (
                    <GenerateInvoiceModalComponent
                        onSuccess={generateInvoiceProps.onSuccess}
                        closeModal={generateInvoiceProps.closeModal}
                    />
                );
            case FINANCES_MODALS.CANCEL_INVOICE:
                return (
                    <CancelInvoiceModalComponent
                        student={generalData?.student}
                        invoice={invoice}
                        closeModal={cancelInvoiceProps.closeModal}
                        onSuccess={cancelInvoiceProps.onSuccess}
                    />
                );
            case FINANCES_MODALS.PAYMENT_DETAIL:
                return (
                    <PaymentDetailModalComponent
                        student={generalData?.student}
                        payment={payment}
                        onReceiptCancelled={paymentDetailProps.onReceiptCancelled}
                        closeModal={paymentDetailProps.closeModal}
                        handleCancelPayment={paymentDetailProps.handleCancelPayment}
                        showPaymentUpdate={paymentDetailProps.showUpdatePayment}
                    />
                );
            case FINANCES_MODALS.EMIT_PAYMENT:
                return (
                    <CobrarEnRegistrar
                        student={generalData?.student}
                        invoice={invoice}
                        totalToPaid={totalToPaid}
                        isPartialPayment={emitPaymentProps.isPartialPayment}
                        isNewInvoice={emitPaymentProps.isNewInvoice}
                        cancel={emitPaymentProps.cancelEmitPayment}
                        showApplyCreditModal={emitPaymentProps.showApplyCreditModal}
                        openRegister={emitPaymentProps.openRegister}
                    />
                );
            case FINANCES_MODALS.CANCEL_PAYMENT:
                return (
                    <CancelPaymentModalComponent
                        student={generalData?.student}
                        payment={payment}
                        closeModal={cancelPaymentProps.closeModal}
                        onSuccess={cancelPaymentProps.onSuccess}
                    />
                );
            case FINANCES_MODALS.APPLY_CREDIT:
                return (
                    <ApplyCreditModalComponent
                        student={generalData?.student}
                        invoice={invoice}
                        itemsInInvoice={itemsInInvoice}
                        totalToPaid={totalToPaid}
                        isPartialPayment={applyCreditProps.isPartialPayment}
                        isNewInvoice={applyCreditProps.isNewInvoice}
                        closeModal={applyCreditProps.closeModal}
                        cancelApplyCredit={applyCreditProps.cancelApplyCredit}
                        onSuccess={applyCreditProps.onSuccess}
                    />
                );
            case FINANCES_MODALS.APPLY_CREDIT_DETAILS:
                return (
                    <CreditDetailModalComponent
                        credit={credit}
                        closeModal={appliedCreditsDetailProps.closeModal}
                    />
                );
            case FINANCES_MODALS.UPDATE_PAYMENT:
                return (
                    <PaymentUpdateModalComponent
                        student={generalData?.student}
                        payment={payment}
                        closeModal={paymentUpdateProps.closeModal}
                        onSuccess={paymentUpdateProps.onSuccess}
                    />
                );
            default:
                dispatch(setShowModal(false));
                return null;
        }
    }

    const renderTransferModalContent = (children: TransferModalsTypes) => {
        switch (children) {
            case TRANSFER_MODAL_CONTENT.SELECT_STUDENT:
                return (
                    <SelectStudentComponent
                        fromStudent={generalData?.student}
                    />
                );
            case TRANSFER_MODAL_CONTENT.TRANSFER:
                return (
                    <TransferCreditModalComponent
                        fromStudent={generalData?.student}
                        toStudent={toStudent}
                        closeModal={transferCreditProps.closeModal}
                        onSuccess={transferCreditProps.onSuccess}
                    />
                );
            default:
                dispatch(setShowTransferCreditModal(false));
                return null;
        }
    }

    /*
        Las acciones de la persona en una sola fila junto al título, con el mismo estilo e icono (Esteban, 2026-11-02: «¿por qué
        Transferir Saldo, Registrar Pago y Cargar Productos están en filas distintas?»). Registrar Pago es la principal (naranja);
        las demás van en contorno. Transferir Saldo solo sale cuando hay crédito a favor que transferir.
    */
    const renderAcciones = () => {
        if (!generalData?.student) return null;
        const puedePagar = !!multiPaymentProps && permissions.includes(PERMISSIONS_CODES.PAYMENT_PERMISSIONS.CREATE);
        const puedeTransferir = permissions.includes(PERMISSIONS_CODES.CREDITS_PERMISSIONS.CREATE) && (generalData?.balance?.positiveBalance?.value || 0) > 0;
        if (!puedePagar && !(cargarProductosProps && puedeCargar) && !puedeTransferir) return null;
        return (
            <div className="ecAcciones">
                {puedePagar ? <button type="button" className="btn btn-primary" onClick={multiPaymentProps.open}><FontAwesomeIcon icon={solid("cash-register")} />{RS.title}</button> : null}
                {cargarProductosProps && puedeCargar ? <button type="button" className="btn btn-outline-secondary" onClick={() => setCargando(true)}><FontAwesomeIcon icon={solid("cart-plus")} />Cargar Productos</button> : null}
                {puedeTransferir ? <button type="button" className="btn btn-outline-secondary" onClick={transferCreditProps.showModal}><FontAwesomeIcon icon={solid("money-bill-transfer")} />{Constants.Common.transferCredit}</button> : null}
            </div>
        );
    }

    return (
        <React.Fragment>
            {!showModal && totalCheckoutItems > 0
                ? <ShoppingCartButtonComponent
                    totalItems={totalCheckoutItems}
                    onClickEvent={accountStatementProps.showCheckoutModal} />
                : <React.Fragment />
            }
            <div className={`transition-width${showModal ? " waFinanzasConPanel" : ""}`}>
                {
                    generalData?.balance && generalData?.student
                        ? <Header
                            balance={generalData.balance}
                            student={generalData.student}
                            actions={renderAcciones()} />
                        // Sin saldos todavía, los botones salen igual (antes Registrar Pago solo pedía al alumno).
                        : generalData?.student ? <div style={{ padding: esTelefono ? "16px 8px 0" : "30px 30px 0" }}>{renderAcciones()}</div> : <React.Fragment />
                }
                {cargando && cargarProductosProps && generalData?.student ? (
                    <CargarProductos campusId={cargarProductosProps.campusId} studentId={generalData.student.id} currency={cargarProductosProps.currencySymbol}
                        onClose={() => setCargando(false)}
                        onDone={(total: number, piezas: number) => { setCargando(false); cargarProductosProps.onDone(total, piezas); }} />
                ) : <React.Fragment />}
                {multiPaymentProps && multiPaymentProps.show ? (
                    <Suspense fallback={<React.Fragment />}>
                        <RegisterPaymentModal campusId={multiPaymentProps.campusId} currencySymbol={multiPaymentProps.currencySymbol}
                            initialStudent={generalData?.student ? { id: generalData.student.id, firstName: generalData.student.firstName, lastName: generalData.student.lastName, identityCode: generalData.student.identityCode } : null}
                            onClose={multiPaymentProps.close} onSuccess={multiPaymentProps.onSuccess} />
                    </Suspense>
                ) : <React.Fragment />}
                {multiPaymentProps && multiPaymentProps.receiptId ? (
                    <Suspense fallback={<React.Fragment />}>
                        <ReceiptDetailModal campusId={multiPaymentProps.campusId} receiptId={multiPaymentProps.receiptId} onClose={multiPaymentProps.closeReceipt} onCancelled={multiPaymentProps.onReceiptCancelled} />
                    </Suspense>
                ) : <React.Fragment />}
                {generalData?.courses.length > 0 ?
                    generalData.courses.map((course: any, index: number) => {
                        return (
                            <div key={`course-row-${index}`}
                                className="row"
                                /*
                                    30px de cada lado se comen 60px de una pantalla de
                                    390px. En telefono se deja el minimo que respira.
                                    (Esteban, 2026-09-16)
                                */
                                style={{
                                    paddingLeft: esTelefono ? "8px" : "30px",
                                    paddingRight: esTelefono ? "8px" : "30px"
                                }}>
                                <div key={`course-col-${index}`}
                                    className="col-lg-12"
                                    style={{ paddingTop: "30px" }}>
                                    {
                                        course.isPlatform && accountStatementProps?.plataformas
                                            ? <AccesoPlataforma campusId={accountStatementProps.plataformas.campusId} enrollmentId={course.enrollmentId}
                                                accessUntil={course.accessUntil} puedeRegalar={true} onChanged={accountStatementProps.plataformas.reload} />
                                            : null
                                    }
                                    <AccountStatementCard
                                        key={course.courseId}
                                        columns={tableProps.tuitionColumns}
                                        data={course}
                                        onEximir={(puedeEximir || tieneCaja) && eximir && course.enrollmentId && !course.isPlatform && course.canExemptMonths ? () => setEximiendo(course) : undefined}
                                        onCambiarPromo={eximir && cambioPromo.puede(course.enrollmentId) && !course.isPlatform && !limpDe(course.enrollmentId) ? () => setCambiandoPromo(course) : undefined}
                                        limpieza={course.enrollmentId && limpDe(course.enrollmentId) ? { canDecide: !!limpDe(course.enrollmentId).canDecide, onRevisar: () => setRevisando(limpDe(course.enrollmentId)) } : undefined}
                                        onCambiarInscripcion={tieneCaja && eximir && !course.isPlatform ? (t) => setCambiandoInsc(t) : undefined}
                                    />
                                </div>
                            </div>
                        )
                    })
                    : <React.Fragment />
                }
                {revisando ? (
                    <LimpiezaDelAlumno campusId={revisando.campusId} studentId={revisando.studentId} enrollmentId={revisando.enrollmentId} nombre={revisando.name}
                        onClose={(cambio: boolean) => { setRevisando(null); setLimpVuelta((n) => n + 1); if (cambio && eximir) eximir.reload(); }} />
                ) : null}
                {cambiandoInsc && eximir ? (
                    <CambiarMontoInscripcion campusId={eximir.campusId} studentId={eximir.studentId} tuition={cambiandoInsc} currencySymbol={eximir.currencySymbol}
                        onClose={() => setCambiandoInsc(null)} onDone={() => eximir.reload()} />
                ) : null}
                {cambiandoPromo && eximir ? (
                    <CambiarPromocion campusId={eximir.campusId} studentId={eximir.studentId} enrollmentId={cambiandoPromo.enrollmentId} courseName={cambiandoPromo.courseName || ""}
                        onClose={() => setCambiandoPromo(null)} onChanged={() => { cambioPromo.recargar(); eximir.reload(); }} />
                ) : null}
                {eximiendo && eximir ? (
                    <EximirMesesModal campusId={eximir.campusId} studentId={eximir.studentId} enrollmentId={eximiendo.enrollmentId}
                        courseName={eximiendo.courseName || ""} currencySymbol={eximir.currencySymbol}
                        onClose={() => setEximiendo(null)} onChanged={() => eximir.reload()} />
                ) : null}
                <div className="row"
                    style={{
                        paddingLeft: esTelefono ? "8px" : "30px",
                        paddingRight: esTelefono ? "8px" : "30px",
                        marginBottom: "30px"
                    }}>
                    <div className="col-lg-6"
                        style={{ paddingTop: "30px" }}>
                        <ArticleCardComponent
                            columns={tableProps.articleColumns}
                            data={generalData.articles}
                            header={Constants.Screens.Finances.accountStatement.productsBalance}
                            type={articleType.LEVEL_KIT}
                        />
                    </div>
                    <div className="col-lg-6"
                        style={{ paddingTop: "30px" }}>
                        <ArticleCardComponent
                            columns={tableProps.articleColumns}
                            data={generalData.articles}
                            header={Constants.Screens.Finances.accountStatement.servicesBalance}
                            type={articleType.SERVICE}
                        />
                    </div>
                </div>
                <Suspense fallback={<div>Loading...</div>}>
                    <AsideModalComponent
                        showModal={showModal}
                        location="right"
                        style={{ width: esTelefono ? "100vw" : "648px" }}>
                        {renderModalContent(modalContent)}
                    </AsideModalComponent>
                </Suspense>

                <Suspense fallback={<div>Loading...</div>}>
                    <ModalComponent
                        title={Constants.Common.transferCredit}
                        showModal={showTransferCreditModal}
                        onClose={transferCreditProps.closeModal}>
                        {renderTransferModalContent(transferModalContent)}
                    </ModalComponent>
                </Suspense>

                <div className="row"
                    style={{
                        paddingLeft: esTelefono ? "8px" : "30px",
                        paddingRight: esTelefono ? "8px" : "30px"
                    }}>
                    <UnderlineHeading
                        name={Constants.Common.historial} />
                </div>

                {generalData?.coursesHistory.length > 0 ?
                    generalData.coursesHistory.map((course: any, index: number) => {
                        return (
                            <div key={`course-row-${index}`}
                                className="row"
                                /*
                                    30px de cada lado se comen 60px de una pantalla de
                                    390px. En telefono se deja el minimo que respira.
                                    (Esteban, 2026-09-16)
                                */
                                style={{
                                    paddingLeft: esTelefono ? "8px" : "30px",
                                    paddingRight: esTelefono ? "8px" : "30px"
                                }}>
                                <div key={`course-col-${index}`}
                                    className="col-lg-12"
                                    style={{ paddingTop: "30px" }}>
                                    <AccountStatementCard
                                        key={course.courseId}
                                        columns={tableProps.tuitionColumns}
                                        data={course}
                                        plegada
                                    />
                                </div>
                            </div>
                        )
                    })
                    : <React.Fragment />
                }

                <div className="row"
                    style={{
                        paddingLeft: esTelefono ? "8px" : "30px",
                        paddingRight: esTelefono ? "8px" : "30px",
                        marginBottom: "30px"
                    }}>
                    <div className="col-lg-6"
                        style={{ paddingTop: "30px" }}>
                        <ArticleCardComponent
                            columns={tableProps.articleColumns}
                            data={generalData.articlesHistory}
                            header={Constants.Screens.Finances.accountStatement.productsBalance}
                            type={articleType.LEVEL_KIT}
                        />
                    </div>
                    <div className="col-lg-6"
                        style={{ paddingTop: "30px" }}>
                        <ArticleCardComponent
                            columns={tableProps.articleColumns}
                            data={generalData.articlesHistory}
                            header={Constants.Screens.Finances.accountStatement.servicesBalance}
                            type={articleType.SERVICE}
                        />
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default AccountStatementView;